import { Injectable } from '@angular/core';
import { TradeInOffer } from 'store/trade-in/models';

@Injectable({
    providedIn: 'root'
})

export class TradeInCmsService {
    public _pageData: CmsTradeInDeviceReportModal;
    public _offerData: TradeInOffer;
}
